import React from "react";
import { Table, Button, Space, Upload } from "antd";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";

export default function LoansTable({
  loans,
  loading,
  onViewSerials,
  onReturnNotSerialized,
}) {
  console.log("prestamo", loans);
  
  return (
    <Table
      dataSource={loans}
      loading={loading}
      columns={[
        { title: "Producto", dataIndex: "product", key: "product" },
        { title: "Cantidad", dataIndex: "quantity", key: "quantity" },
        {
          title: "Precio unitario",
          dataIndex: "price",
          render: (price) => `$${price}`,
        },
        {
          title: "Id del prestamo",
          dataIndex: "loanId",
          key: "loanId",
          render: (loanId, record) => {
            // Si hay múltiples préstamos, mostrarlos todos
            if (record.loanIds && record.loanIds.length > 1) {
              return record.loanIds.join(", ");
            }
            return loanId;
          },
        },
        {
          title: "Impuesto",
          dataIndex: "tax",
          render: (tax) => `${tax}%`,
        },
        {
          title: "Total parcial",
          dataIndex: "partialTotal",
          render: (total) => `$${total}`,
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle">
              {record.isNotSerialized ? (
                <Button
                  onClick={() => onReturnNotSerialized(record)}
                  type="primary"
                >
                  Devolver productos
                </Button>
              ) : (
                <>
                  <Button
                    onClick={() => onViewSerials(record)}
                    icon={<EyeOutlined />}
                    type="primary"
                  >
                    Ver seriales
                  </Button>
                </>
              )}
            </Space>
          ),
        },
      ]}
      locale={{
        emptyText: "No hay préstamos pendientes para este vendedor",
      }}
    />
  );
}
